<template>
  <div class="content-body">
    <QrCode
      ref="QrCode"
      :name="'QrCode'"
      @onQr="getQRSerial"
      :manual="true"
      :serialME="true"
      :photo="camMode"
      @onPhoto="getCamRes"
      @onClose="closingQr"
    />

    <modalImg ref="imgzoomC" :name="'modalImg'" :arrImg="modalArr" />

    <vue-modal :on-close="closeModalMap" name="map-modal">
      <h5 slot="header" style="text-align: center">{{ modalMap.title }}</h5>
      <div class="row row-map">
        <GmapMap
          :center="modalMap.position"
          :zoom="17"
          map-type-id="terrain"
          style="height: 600px"
        >
          <GmapMarker
            :position="modalMap.position"
            :clickable="true"
            :draggable="true"
          />
        </GmapMap>
      </div>
      <br />
      <div class="row">
        <div class="col-md-12 mb-3"></div>
      </div>
    </vue-modal>

    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h4 class="form-section" ref="eqAbout" v-if="!actEqs">
              <i class="icon-redo2"></i> {{ $t("titles.activation") }}
              {{ dataEquipment.serial }}
            </h4>
            <h4 class="form-section" ref="eqAbout" v-if="actEqs">
              <i class="icon-stack"></i> {{ $t("equipm.titles.actEqs") }}
            </h4>
            <div class="heading-elements"></div>
          </div>

          <div class="card-body">
            <div class="card-block">
              <div class="row" v-if="!showinfo && !actEqs && !actGroupEq">
                <div class="col-md-4 mb-1">
                  <!--  -->
                  <div class="input-group">
                    <div
                      class="form-control border-primary"
                      style="background-color: #eceeef"
                      id="typeFltr"
                      @click="filterTypes = !filterTypes"
                    >
                      {{ typeTitle() }}
                    </div>

                    <div class="input-group-append">
                      <button
                        type="button"
                        class="btn btn-primary btn-round"
                        @click="filterTypes = !filterTypes"
                      >
                        <a class="dropdown-toggle" style="color: white"></a>
                      </button>
                    </div>
                  </div>
                  <div class="dropdown-menu w-100" v-if="filterTypes">
                    <button
                      v-for="(item, index) in $store.state.eq_type"
                      :key="index"
                      class="dropdown-item"
                      type="button"
                      @click="
                        filterType = item.id;
                        filterTypes = !filterTypes;
                      "
                    >
                      {{ $t(item.translate) }}
                    </button>
                  </div>
                </div>
              </div>

              <ul class="nav nav-tabs" v-if="showinfo && !actGroupEq">
                <li
                  class="nav-item"
                  data-html="true"
                  :title="$t('tasks.hint.detail') + ' ' + dataEquipment.serial"
                >
                  <a
                    class="nav-link"
                    v-bind:class="{ active: dataEquipment.tabs.info }"
                    id="base-tab1"
                    data-toggle="tab"
                    @click="dataEquipment.tabs.info = true"
                  >
                    <i class="icon-info"></i>
                  </a>
                </li>
                <li
                  class="nav-item"
                  data-html="true"
                  :title="$t('tasks.titles.history')"
                >
                  <a
                    class="nav-link"
                    v-bind:class="{ active: dataEquipment.tabs.history }"
                    id="base-tab4"
                    data-toggle="tab"
                    @click="dataEquipment.tabs.history = true"
                  >
                    <i class="icon-history"></i>
                  </a>
                </li>
              </ul>

              <div
                class="row"
                v-if="dataEquipment.tabs.info && showinfo && !actGroupEq"
              >
                <div
                  class="col-md-6"
                  :class="{
                    'offset-md-3': dataEquipment.ProductType != 'Refrigeration',
                  }"
                >
                  <div class="form-body">
                    <form class="form">
                      <h4 class="form-section">
                        <i class="icon-eye6"></i>
                        {{ $t("equipm.titles.details") }}
                      </h4>
                    </form>
                    <div class="form-group">
                      <label for="serial">{{
                        $t("equipm.table.serNumber")
                      }}</label>
                      <div class="position-relative has-icon-left">
                        <input
                          class="form-control border-primary"
                          type="text"
                          id="serial"
                          v-model="dataEquipment.serial"
                          disabled
                        />
                        <div class="form-control-position">
                          <i class="icon-qrcode"></i>
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="nameEq">{{
                        $t("equipm.table.nameEq")
                      }}</label>
                      <div
                        class="form-control border-primary"
                        style="background-color: #eceeef; min-height: 2em"
                      >
                        {{ dataEquipment.name }}
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="nameEq">{{
                        $t("equipm.table.extName")
                      }}</label>
                      <input
                        type="text"
                        id="extnameEq"
                        class="form-control border-primary"
                        name="extnameEq"
                        v-model="dataEquipment.ExternalName"
                      />
                    </div>

                    <form class="form">
                      <h4 class="form-section">
                        <i class="icon-mail6"></i>
                        {{ $t("equipm.titles.infoAbManuf") }}
                      </h4>
                    </form>
                    <div class="form-group">
                      <label for="contacts">{{
                        $t("equipm.table.contacts")
                      }}</label>
                      <div class="position-relative has-icon-left">
                        <!--<input class="form-control border-primary" type="tel" placeholder="phone number" id="userinput5" pattern="[+]{1}[0-9]{11,14}" v-model="dataEquipment.contacts" disabled>-->
                        <textarea
                          id="contacts"
                          name="contacts"
                          rows="4"
                          class="form-control border-primary"
                          v-model="dataEquipment.contacts"
                          disabled
                        ></textarea>
                        <div class="form-control-position">
                          <i class="icon-address-book"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="col-md-6"
                  v-if="dataEquipment.ProductType == 'Refrigeration'"
                >
                  <div class="row">
                    <div class="col-md-12">
                      <form class="form">
                        <h4 class="form-section">
                          <i class="icon-file-text2"></i>
                          {{ $t("equipm.titles.characters") }}
                        </h4>
                      </form>

                      <div class="row">
                        <div class="col-md-4">
                          <div class="form-group">
                            <label for="climaticClass">{{
                              $t("equipm.table.clClass")
                            }}</label>
                            <div class="position-relative has-icon-left">
                              <input
                                type="text"
                                id="climaticClass"
                                class="form-control border-primary"
                                name="climaticClass"
                                v-model="dataEquipment.climaticClass"
                                disabled
                              />
                              <div class="form-control-position">
                                <i class="icon-brightness-contrast"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <label for="defrosting">{{
                              $t("equipm.table.defrosting")
                            }}</label>
                            <div class="position-relative has-icon-left">
                              <input
                                type="text"
                                id="defrosting"
                                class="form-control border-primary"
                                name="defrosting"
                                v-model="dataEquipment.defrosting"
                                disabled
                              />
                              <div class="form-control-position">
                                <i class="icon-svg"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <label for="maxPressure">{{
                              $t("equipm.table.maxPress")
                            }}</label>
                            <div class="position-relative has-icon-left">
                              <input
                                type="text"
                                id="maxPressure"
                                class="form-control border-primary"
                                name="maxPressure"
                                v-model="dataEquipment.maxPressure"
                                disabled
                              />
                              <div class="form-control-position">
                                <i class="icon-meter"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-4">
                          <div class="form-group">
                            <label for="protectionClass">{{
                              $t("equipm.table.protClass")
                            }}</label>
                            <div class="position-relative has-icon-left">
                              <input
                                type="text"
                                id="protectionClass"
                                class="form-control border-primary"
                                name="protectionClass"
                                v-model="dataEquipment.protectionClass"
                                disabled
                              />
                              <div class="form-control-position">
                                <i class="icon-security"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <label for="ratedCurrent">{{
                              $t("equipm.table.currCons")
                            }}</label>
                            <div class="position-relative has-icon-left">
                              <input
                                type="text"
                                id="ratedCurrent"
                                class="form-control border-primary"
                                name="ratedCurrent"
                                v-model="dataEquipment.ratedCurrent"
                                disabled
                              />
                              <div class="form-control-position">
                                <i class="icon-power2"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <label for="ratedPinp">{{
                              $t("equipm.table.pwrConsump")
                            }}</label>
                            <div class="position-relative has-icon-left">
                              <input
                                type="text"
                                id="ratedPinp"
                                class="form-control border-primary"
                                name="ratedPinp"
                                v-model="dataEquipment.ratedPinp"
                                disabled
                              />
                              <div class="form-control-position">
                                <i class="icon-power-cord"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <form class="form">
                    <h4 class="form-section">
                      <i class="icon-file-text"></i>
                      {{ $t("equipm.titles.specif") }}
                    </h4>
                  </form>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="artcile">{{
                          $t("equipm.table.articule")
                        }}</label>
                        <div class="position-relative has-icon-left">
                          <input
                            type="text"
                            id="artcile"
                            class="form-control border-primary"
                            name="artcile"
                            v-model="dataEquipment.article"
                            disabled
                          />
                          <div class="form-control-position">
                            <i class="icon-price-tags"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="titleRefr">{{
                          $t("equipm.table.refrigerant")
                        }}</label>
                        <div class="position-relative has-icon-left">
                          <input
                            type="text"
                            id="titleRefr"
                            class="form-control border-primary"
                            name="titleRefr"
                            v-model="titleRefr"
                            disabled
                          />
                          <div class="form-control-position">
                            <i class="icon-lab"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="dtShipment">{{
                          $t("equipm.table.shipmDate")
                        }}</label>
                        <div class="position-relative has-icon-left">
                          <!--<input type="date" id="dtinput1" class="form-control" name="dtShipment" v-model="dataEquipment.dates.shipment" disabled>-->
                          <input
                            type="text"
                            id="dtShipment"
                            class="form-control"
                            name="dtShipment"
                            v-model="dataEquipment.dates.shipment"
                            disabled
                          />
                          <div class="form-control-position">
                            <i class="icon-calendar3"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="dtManufacturing">{{
                          $t("equipm.table.manufDate")
                        }}</label>
                        <div class="position-relative has-icon-left">
                          <input
                            type="text"
                            id="dtManufacturing"
                            class="form-control"
                            name="dtManufacturing"
                            v-model="dataEquipment.dates.manufacturing"
                            disabled
                          />
                          <div class="form-control-position">
                            <i class="icon-calendar3"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="row"
                v-if="
                  dataEquipment.components.length > 0 &&
                  dataEquipment.tabs.info &&
                  showinfo &&
                  !actGroupEq
                "
              >
                <div class="col-md-12">
                  <form class="form">
                    <h4 class="form-section mb-0">
                      <i class="icon-stack"></i>
                      {{ $t("equipm.titles.components") }}
                    </h4>
                  </form>
                  <div class="col-md-8 offset-md-2">
                    <div class="mobileTbl table-responsive">
                      <table class="table table-hover mb-0" cellspacing="0">
                        <thead>
                          <tr>
                            <th style="vertical-align: middle">
                              {{ $t("equipm.table.nameEq") }}
                            </th>
                            <th style="vertical-align: middle">
                              {{ $t("equipm.table.serNumber") }}
                            </th>
                            <th style="vertical-align: middle">
                              {{ $t("equipm.table.count") }}
                            </th>
                            <th style="vertical-align: middle">
                              {{ $t("equipm.table.manufacturer") }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(item, index) in dataEquipment.components"
                            :key="index"
                          >
                            <td :data-title="$t('equipm.table.nameEq')">
                              {{ item.Item }}
                            </td>
                            <td :data-title="$t('equipm.table.serNumber')">
                              <a @click="showComponDetail(item)">{{
                                item.ItemSN
                              }}</a>
                            </td>
                            <td :data-title="$t('equipm.table.count')">
                              {{ item.Quantity }}
                            </td>
                            <td :data-title="$t('equipm.table.manufacturer')">
                              {{ item.Manufacturer }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="row"
                v-if="dataEquipment.tabs.info && showinfo && !actGroupEq"
              >
                <div class="col-md-12">
                  <form class="form">
                    <h4 class="form-section">
                      <a
                        v-if="
                          dataEquipment.address != null &&
                          dataEquipment.address.length > 5
                        "
                        class=""
                        @click="
                          showModalMapByAddr(
                            dataEquipment.address,
                            dataEquipment.serial
                          )
                        "
                      >
                        <i class="icon icon-location2"></i
                      ></a>
                      <i v-else class="icon-location2"></i>
                      <span>{{ $t("equipm.table.location") }}</span>
                    </h4>
                  </form>

                  <div class="form-group col-md-8 mt-1 mb-0">
                    <input
                      type="text"
                      id="address_old"
                      name="address_old"
                      class="form-control border-primary"
                      v-model="dataEquipment.address"
                    />
                  </div>
                </div>

                <div class="col-md-12 mt-1">
                  <form class="form">
                    <h4 class="form-section">
                      <i class="icon-attachment"></i>
                      {{ $t("tasks.table.images") }}
                    </h4>
                  </form>

                  <div class="form-group">
                    <input
                      type="file"
                      name="file"
                      id="file"
                      class="inputfile"
                      multiple="multiple"
                      accept="image/x-png,image/jpeg"
                      @change="onUploadImg"
                    />
                    <label id="file_loader" for="file">
                      <a class="btn btn-primary btn-min-width"
                        ><i class="icon-upload3"></i>
                        {{ $t("tasks.buttons.file") }}</a
                      >
                    </label>

                    <!-- <button type="button" class="btn btn-warning" data-toggle="modal" data-target="#modalCAM" @click="$store.state.active_cam = true">
                                        <i style="color: #FFFFFF" class="icon-camera8"></i> {{$t('tasks.buttons.photo')}}
                                    </button> -->
                    <button
                      type="button"
                      class="btn btn-warning"
                      @click="
                        camMode = true;
                        showModalQR();
                      "
                      data-html="true"
                      :title="$t('equipm.hint.camera')"
                    >
                      <i style="color: #ffffff" class="icon-camera8"></i>
                      {{ $t("tasks.buttons.photo") }}
                    </button>
                    <button
                      type="button"
                      class="btn btn-danger"
                      @click="
                        dataEquipment.images = [];
                        dataEquipment.images2 = [];
                      "
                      v-if="dataEquipment.images.length > 0"
                    >
                      <i class="icon-bin"></i> {{ $t("tasks.buttons.remove") }}
                    </button>
                  </div>

                  <div class="row">
                    <div
                      class="col-md-12"
                      style="display: flex; flex-wrap: wrap"
                    >
                      <div
                        class="col-xs-3"
                        style="
                          padding: 0;
                          display: flex;
                          flex-direction: column;
                          align-content: center;
                          justify-content: center;
                          margin-bottom: 1em;
                        "
                        v-for="(image, index) in dataEquipment.images"
                        :key="index"
                      >
                        <div class="card hand mb-0" style="margin-left: 5px">
                          <div class="w-100 h-100">
                            <i
                              class="icon-cross delete-image-icon"
                              @click="
                                dataEquipment.images.splice(index, 1);
                                dataEquipment.images2.splice(index, 1);
                              "
                              data-html="true"
                              :title="$t('tasks.hint.delImg')"
                            ></i>
                            <img
                              v-bind:src="image.data"
                              style="max-width: 100%; max-height: 100%"
                              @click="expandDiv(dataEquipment.images, index)"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="row"
                v-if="dataEquipment.tabs.history && showinfo && !actGroupEq"
              >
                <div class="col-md-12">
                  <form class="form">
                    <h4 class="form-section">
                      <i class="icon-history"></i> {{ $t("titles.history") }}
                    </h4>
                  </form>

                  <div class="mobileTbl table-responsive">
                    <table class="table table-hover mb-0" cellspacing="0">
                      <thead>
                        <tr>
                          <th
                            class="text-truncate"
                            style="vertical-align: middle"
                          >
                            {{ $t("tasks.table.docNumb") }}
                          </th>
                          <th style="vertical-align: middle">
                            {{ $t("tasks.table.date") }}
                          </th>
                          <th style="vertical-align: middle">
                            {{ $t("tasks.table.status") }}
                          </th>
                          <th style="vertical-align: middle">
                            {{ $t("tasks.table.execPers") }}
                          </th>
                          <th style="vertical-align: middle">
                            {{ $t("tasks.table.jobs") }}
                          </th>
                          <th></th>
                        </tr>
                      </thead>

                      <tbody
                        v-for="(eq, index) in dataEquipment.history"
                        :key="index"
                      >
                        <tr class="hand" @click="showModalTaskinfo(eq.GUID)">
                          <td
                            class="text-truncate"
                            :data-title="$t('tasks.table.docNumb')"
                          >
                            <span>{{ eq.DocNumber }}</span>
                          </td>
                          <td
                            class="text-truncate"
                            :data-title="$t('tasks.table.date')"
                          >
                            <span>{{ eq.Date }}</span>
                          </td>
                          <td
                            class="text-truncate"
                            :data-title="$t('tasks.table.status')"
                          >
                            <span
                              class="tag"
                              :class="$t('tasks.' + eq.Status + '.class')"
                            >
                              {{ $t("tasks." + eq.Status + ".title") }}
                            </span>
                          </td>
                          <td :data-title="$t('tasks.table.execPers')" class="">
                            <span>{{ eq.Executor }}</span>
                          </td>
                          <td :data-title="$t('tasks.table.jobs')" class="">
                            <span>{{ eq.JobS }}</span>
                          </td>
                          <td class="text-truncate">
                            <div
                              class="row"
                              style="float: right; margin-right: 5px"
                            >
                              <button
                                type="button"
                                class="btn btn-warning"
                                @click="showModalTaskinfo(eq.GUID)"
                              >
                                <i class="icon-info"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                        <tr v-if="eq.jobs != null">
                          <td></td>
                          <td colspan="4">
                            <span style="font-size: 0.8em">{{ eq.jobs }}</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <form class="form">
                <div class="form-actions right" v-if="showinfo && !actGroupEq">
                  <button
                    type="button"
                    class="btn btn-danger mr-1"
                    @click="filterType = null"
                  >
                    <i class="icon-cross2"></i>
                    {{ $t("equipm.buttons.cancel") }}
                  </button>
                  <button
                    type="button"
                    class="btn btn-success"
                    @click="activateEq()"
                  >
                    <i class="icon-check2"></i> {{ $t("equipm.buttons.add") }}
                  </button>
                </div>
              </form>

              <div class="row" v-if="actEqs && actGroupEq">
                <div class="col-md-6 mb-1">
                  <div class="form-group">
                    <label for="nameEqs">{{ $t("equipm.table.nameEq") }}</label>
                    <input
                      class="form-control border-primary"
                      type="text"
                      id="nameEqs"
                      v-model="activating.name"
                    />
                  </div>

                  <h5>{{ $t("titles.eq1") }}</h5>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <button
                        type="button"
                        class="btn btn-primary btn-round"
                        @click.self="showModalQR()"
                        data-html="true"
                        :title="$t('equipm.hint.scanQr')"
                      >
                        <i class="icon-qrcode"></i>
                      </button>
                    </div>
                    <input
                      class="form-control border-primary"
                      type="text"
                      :placeholder="$t('equipm.table.serNumber')"
                      id="serial_enter"
                      v-model="dataEquipment.serial"
                      @change="addSerial()"
                    />
                    <div class="input-group-append">
                      <button
                        type="button"
                        class="btn btn-warning btn-round"
                        @click="addSerial()"
                      >
                        <i style="color: #ffffff" class="icon-plus2"></i>
                        {{ $t("tasks.buttons.addSerial") }}
                      </button>
                    </div>
                  </div>
                </div>

                <div class="col-md-6" v-if="activating.serials.length > 0">
                  <div
                    class="mobileTbl table-responsive"
                    v-if="activating.serials.length > 0"
                  >
                    <table class="table table-hover mb-0" cellspacing="0">
                      <thead>
                        <tr>
                          <th style="vertical-align: middle">
                            {{ $t("equipm.table.mainSer") }}
                          </th>
                          <th style="vertical-align: middle">
                            {{ $t("equipm.table.serNumber") }}
                          </th>
                          <th style="vertical-align: middle"></th>
                        </tr>
                      </thead>
                      <tbody
                        v-for="(eq, index) in activating.serials"
                        :key="index"
                      >
                        <tr>
                          <td class="hand" @click="checkMain(eq)">
                            <i
                              :class="[
                                eq.check
                                  ? 'icon-checkbox-checked'
                                  : 'icon-checkbox-unchecked',
                              ]"
                              style="vertical-align: middle"
                            ></i>
                          </td>
                          <td
                            :data-title="$t('equipm.table.serNumber')"
                            class="hand"
                            @click="checkMain(eq)"
                          >
                            <span>{{ eq.serial }}</span>
                          </td>
                          <td style="vertical-align: middle">
                            <button
                              type="button"
                              class="btn btn-warning"
                              style="float: right"
                              v-on:click="activating.serials.splice(index, 1)"
                            >
                              <i class="icon-bin"></i>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div class="row" v-if="actEqs">
                <div class="col-md-12">
                  <form class="form">
                    <h4 class="form-section">
                      <i class="icon-attachment"></i>
                      {{ $t("tasks.table.images") }}
                    </h4>
                  </form>

                  <div class="form-group">
                    <input
                      type="file"
                      name="file"
                      id="file"
                      class="inputfile"
                      multiple="multiple"
                      accept="image/x-png,image/jpeg"
                      @change="onUploadImg"
                    />
                    <label id="file_loader" for="file">
                      <a class="btn btn-primary btn-min-width"
                        ><i class="icon-upload3"></i>
                        {{ $t("tasks.buttons.file") }}</a
                      >
                    </label>

                    <!-- <button type="button" class="btn btn-warning" data-toggle="modal" data-target="#modalCAM" @click="$store.state.active_cam = true">
                                        <i style="color: #FFFFFF" class="icon-camera8"></i> {{$t('tasks.buttons.photo')}}
                                    </button> -->
                    <button
                      type="button"
                      class="btn btn-warning"
                      @click="
                        camMode = true;
                        showModalQR();
                      "
                      data-html="true"
                      :title="$t('equipm.hint.camera')"
                    >
                      <i style="color: #ffffff" class="icon-camera8"></i>
                      {{ $t("tasks.buttons.photo") }}
                    </button>
                    <button
                      type="button"
                      class="btn btn-danger"
                      @click="
                        dataEquipment.images = [];
                        dataEquipment.images2 = [];
                      "
                      v-if="dataEquipment.images.length > 0"
                    >
                      <i class="icon-bin"></i> {{ $t("tasks.buttons.remove") }}
                    </button>
                  </div>
                </div>
              </div>

              <div class="row" v-if="actEqs">
                <div class="col-md-12" style="display: flex; flex-wrap: wrap">
                  <div
                    class="col-xs-3"
                    style="
                      padding: 0;
                      display: flex;
                      flex-direction: column;
                      align-content: center;
                      justify-content: center;
                      margin-bottom: 1em;
                    "
                    v-for="(image, index) in dataEquipment.images"
                    :key="index"
                  >
                    <div class="card hand mb-0" style="margin-left: 5px">
                      <div class="w-100 h-100">
                        <i
                          class="icon-cross delete-image-icon"
                          @click="
                            dataEquipment.images.splice(index, 1);
                            dataEquipment.images2.splice(index, 1);
                          "
                          data-html="true"
                          :title="$t('tasks.hint.delImg')"
                        ></i>
                        <img
                          v-bind:src="image.data"
                          style="max-width: 100%; max-height: 100%"
                          @click="expandDiv(dataEquipment.images, index)"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mt-1" v-if="actEqs">
                <form class="form">
                  <div class="form-actions right">
                    <button
                      type="button"
                      class="btn btn-danger"
                      @click="
                        actEqs = false;
                        actGroupEq = false;
                        filterType = null;
                      "
                      data-html="true"
                    >
                      <i class="icon-cross2"></i>
                      {{ $t("equipm.buttons.cancel") }}
                    </button>
                    <button
                      type="button"
                      class="btn btn-success"
                      @click="activatingMulti()"
                    >
                      <i class="icon-checkmark2"></i>
                      {{ $t("equipm.buttons.add") }}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-if="actEqs && !showinfo"></div>
  </div>
</template>

<script>
import fileDownload from "js-file-download";
import _debounce from "lodash";

export default {
  name: "Activation",
  data() {
    return {
      camMode: false,

      //displaing info
      showinfo: false,
      dataEquipment: {
        guid: null,
        serial: null, //ме-20123469393
        name: "",
        ExternalName: null,
        brand: "",
        ProductType: null,
        article: "",
        refrigerant: {
          weight: "",
          name: "",
        },
        address: null,
        addressT: {
          country: null,
          region: null,
          city: null,
          street: null,
          streetN: null,
          index: null,
        },
        components: [],
        dates: {
          manufacturing: "",
          shipment: "",
        },
        contacts: "",
        climaticClass: "",
        defrosting: "",
        lightning: "",
        maxPressure: "",
        protectionClass: "",
        ratedCurrent: "",
        ratedPinp: "",
        instruсtions: [],
        ArrayPhoto: [],

        images: [],
        images2: [],

        countLoad: 3,
        countPhoto: 0,

        tabs: {
          info: true,
          history: false,
        },
      },

      actEqs: false,
      actGroupEq: false,
      activating: {
        name: null,
        address: null,
        serials: [],
        main: null,
      },

      position: {
        latitude: null,
        longitude: null,
        accuracy: null,
      },

      filterTypes: false,
      filterType: null,

      filesLimit: 7,

      modalMap: {
        position: { lat: null, lng: null },
        title: "",
      },

      modalArr: [],
    };
  },
  props: {},
  methods: {
    onUploadImg(e) {
      let tt = null;
      let _this = this;
      if (e.target.files.length > 0) {
        let files = e.target.files;

        if (files.length > this.filesLimit) {
          this.$notify({
            group: "info",
            title: "Warning",
            text: "Ліміт файлів " + this.filesLimit,
          });
          files.splice(this.filesLimit);
        }

        for (let i = 0; i < files.length; i++) {
          const element = files[i];
          const reader = new FileReader();
          reader.readAsDataURL(element);
          reader.onload = (e) => {
            var img = new Image();
            img.onload = function () {
              if (img.width > 1500) {
                //зжимання
                var w = img.width;
                var h = img.height;
                var canvas = document.createElement("canvas");
                var ctx = canvas.getContext("2d"); // Создаем узел атрибута
                var anw = document.createAttribute("width");
                anw.nodeValue = w;
                var anh = document.createAttribute("height");
                anh.nodeValue = h;
                canvas.setAttributeNode(anw);
                canvas.setAttributeNode(anh);
                ctx.drawImage(img, 0, 0, w, h);
                var base64Img = canvas.toDataURL("image/jpeg", 0.6);
                //зжимання

                tt = base64Img.split(",");
              } else {
                tt = img.src.split(",");
              }

              let err = false;
              if (_this.dataEquipment.images.length <= _this.filesLimit) {
                let nameFile;
                if (_this.actEqs) {
                  if (_this.activating.main == null) {
                    nameFile =
                      _this.activating.serials[0].serial +
                      "_" +
                      Math.floor(Math.random() * 4999) +
                      ".png";
                  } else {
                    nameFile =
                      _this.activating.main +
                      "_" +
                      Math.floor(Math.random() * 4999) +
                      ".png";
                  }
                } else {
                  nameFile =
                    _this.dataEquipment.serial +
                    "_" +
                    Math.floor(Math.random() * 4999) +
                    ".png";
                }
                _this.dataEquipment.images.push({
                  name: nameFile,
                  data: tt[0] + "," + tt[1],
                }); //'actEq_'
                _this.dataEquipment.images2.push({
                  name: nameFile,
                  data: tt[1],
                });
              } else {
                err = true;
              }

              if (err) {
                _this.$notify({
                  group: "info",
                  title: "Warning",
                  text: "Ліміт файлів " + _this.filesLimit,
                });
              }
            };
            img.src = e.target.result;
          };
        }
      }
    },
    getCamRes(dataCam) {
      this.camMode = false;
      if (this.isValid(dataCam)) {
        let nameFile;
        if (this.actEqs) {
          if (this.activating.main == null) {
            nameFile =
              this.activating.serials[0].serial +
              "_" +
              Math.floor(Math.random() * 4999) +
              ".png";
          } else {
            nameFile =
              this.activating.main +
              "_" +
              Math.floor(Math.random() * 4999) +
              ".png";
          }
        } else {
          nameFile =
            this.dataEquipment.serial +
            "_" +
            Math.floor(Math.random() * 4999) +
            ".png";
        }
        this.dataEquipment.images.push({ name: nameFile, data: dataCam });
        this.dataEquipment.images2.push({
          name: nameFile,
          data: dataCam.split(",")[1],
        });
      }
    },
    expandDiv(arr, ind) {
      if (arr[0].data != undefined) {
        let arr2 = [];
        for (let i = 0; i < arr.length; i++) {
          arr2.push(arr[i].data);
        }
        arr = arr2;
      }

      $("#modalImg").modal("show");
      this.$refs.imgzoomC.onShow(ind, arr);
    },
    loadHistory() {
      this.dataEquipment.history = [];
      let dataRequest = {
        number: this.dataEquipment.serial,
        guid: this.dataEquipment.guid,
      };

      this.makeQuery("/service/getHistoryTask", {
        dataRequest: dataRequest,
        token: this.$store.getters.getUserToken,
      })
        .then((result) => {
          if (result != undefined && result.length > 0) {
            for (let i = 0; i < result.length; i++) {
              if (result[i].Date != null) {
                result[i].Date = this.dtFormat(result[i].Date);
              }

              if (result[i].Date != null) {
                result[i].StatusTXT = result[i].Status;

                //set status translate
                if (result[i].StatusBP == 1) {
                  //СогласованиеЗаявки
                  result[i].Status = "statuses.new";
                } else if (result[i].StatusBP == 2) {
                  result[i].Status = "statuses.agreed";
                } else if (result[i].StatusBP == 3) {
                  //ВыполнениеЗаявки
                  result[i].Status = "statuses.process";
                } else if (result[i].StatusBP == 4) {
                  //ВнесениеЗатрат
                  result[i].Status = "statuses.finish";
                } else if (result[i].StatusBP == 5) {
                  result[i].Status = "statuses.done";
                } else if (result[i].StatusBP == 6) {
                  result[i].Status = "statuses.cancel";
                }

                if (this.isValid(result[i].Comment)) {
                  result[i].jobs = result[i].Comment;
                } else {
                  result[i].jobs = null;
                }

                this.dataEquipment.history.push(result[i]);
              }
            }
          }
        })
        .catch((result) => {
          this.showNotification("custom-error", "Error", result);
        });
    },
    getEqInfo(serial) {
      this.discardAct();
      //ме-21063496548

      let dataRequest = {
        serial: serial,
        userGuid: this.$store.getters.getGuidUser,
        guidClient: this.$store.state.guidClient,
      };
      this.dataEquipment.serial = serial;

      this.makeQuery("/service/productSerialSite", {
        dataRequest: dataRequest,
        token: this.$store.getters.getUserToken,
      })
        .then((result) => {
          this.dataEquipment.article = result.Articule;

          if (result.GUID != undefined) {
            this.dataEquipment.guid = result.GUID;
          }
          this.dataEquipment.ProductType = result.ProductType;
          if (this.dataEquipment.ProductType == "FMCG Refrigeration") {
            this.dataEquipment.ProductType = "Refrigeration";
          }

          if (result.Goods == "" || result.Goods == null) {
            this.dataEquipment.name =
              this.dataEquipment.ProductType +
              " (" +
              this.dataEquipment.serial +
              ")";
          } else {
            this.dataEquipment.name = result.Goods;
          }
          if (result.ExternalName != undefined) {
            this.dataEquipment.ExternalName = result.ExternalName;
          }

          this.dataEquipment.contacts = result.ContactInfo;

          this.dataEquipment.dates.manufacturing = this.dtFormat(
            result.DateOfProduction
          );
          this.dataEquipment.dates.shipment = this.dtFormat(
            result.DateOfShipment
          );

          this.dataEquipment.refrigerant.weight = result.RefrigerantMass;
          this.dataEquipment.refrigerant.name = result.RefrigerantBrand;
          this.dataEquipment.climaticClass = result.ClimaticClass;
          this.dataEquipment.defrosting = result.Defrosting;
          this.dataEquipment.lightning = result.Lightning;
          this.dataEquipment.maxPressure = result.MaxPressure;
          this.dataEquipment.protectionClass = result.ProtectionClass;
          this.dataEquipment.ratedCurrent = result.RatedCurrent;
          this.dataEquipment.ratedPinp = result.RatedPowerInput;

          this.dataEquipment.address = result.Adress;
          /*if((result.AdressSructure != undefined) && (result.AdressSructure != null)){
                        this.dataEquipment.addressT.country = result.AdressSructure.Country;
                        this.dataEquipment.addressT.region = result.AdressSructure.Region;
                        this.dataEquipment.addressT.city = result.AdressSructure.Location;
                        this.dataEquipment.addressT.street = result.AdressSructure.Street;
                        this.dataEquipment.addressT.streetN = result.AdressSructure.StreetN;
                        this.dataEquipment.addressT.index = result.AdressSructure.PostalCode;
                    }
                    this.dataEquipment.addressBefCH = Object.assign({}, this.dataEquipment.addressT);*/

          if (result.ItemStructure != undefined) {
            for (let index = 0; index < result.ItemStructure.length; index++) {
              this.dataEquipment.components.push(result.ItemStructure[index]);
            }
          }

          if (result.quantityPhoto != undefined) {
            this.dataEquipment.countPhoto = result.quantityPhoto;
            //this.loadPictures();
          }

          /*
                    if((result.ArrayPhoto != undefined) && (result.ArrayPhoto.length > 0)){
                        for (let i = 0; i < result.ArrayPhoto.length; i++) {
                            this.dataEquipment.ArrayPhoto.push({name: result.ArrayPhoto[i].name, data: 'data:image/png;base64,' + result.ArrayPhoto[i].data});
                        }
                    }
                    */

          // if(result.ArrayFiles != undefined) {
          //     this.dataEquipment.instruсtions = [];

          //     let file;
          //     for (let i = 0; i < result.ArrayFiles.length; i++) {
          //         file = result.ArrayFiles[i].name;
          //         if(file != null){
          //             this.dataEquipment.instruсtions.push({name: file, data: null});
          //         }
          //     }

          // }

          this.showinfo = true;

          this.dataEquipment.tabs.info = true;

          this.anchorTo("eqAbout");
        })
        .catch((result) => {
          this.showNotification("custom-error", "Error", result);
        });
    },
    discardAct() {
      this.dataEquipment.serial = null;
      this.dataEquipment.guid = null;
      this.dataEquipment.name = null;
      this.dataEquipment.ExternalName = null;
      this.dataEquipment.brand = null;
      this.dataEquipment.ProductType = null;
      this.dataEquipment.article = null;
      this.dataEquipment.refrigerant.weight = null;
      this.dataEquipment.refrigerant.name = null;
      this.dataEquipment.dates.manufacturing = null;
      this.dataEquipment.dates.shipment = null;
      this.dataEquipment.contacts = null;
      this.dataEquipment.climaticClass = null;
      this.dataEquipment.defrosting = null;
      this.dataEquipment.lightning = null;
      this.dataEquipment.maxPressure = null;
      this.dataEquipment.protectionClass = null;
      this.dataEquipment.ratedCurrent = null;
      this.dataEquipment.ratedPinp = null;

      this.dataEquipment.address = null;

      this.dataEquipment.addressT.country = null;
      this.dataEquipment.addressT.region = null;
      this.dataEquipment.addressT.city = null;
      this.dataEquipment.addressT.street = null;
      this.dataEquipment.addressT.streetN = null;
      this.dataEquipment.addressT.index = null;

      this.dataEquipment.components = [];
      this.dataEquipment.instruсtions = [];
      this.dataEquipment.ArrayPhoto = [];
      this.dataEquipment.countPhoto = 0;

      this.dataEquipment.images = [];
      this.dataEquipment.images2 = [];

      this.dataEquipment.tabs.info = false;
      this.dataEquipment.tabs.history = false;

      this.dataEquipment.history = [];

      this.activating.name = null;
      this.activating.main = null;
      this.activating.address = null;
      this.activating.serials = [];
    },
    activateEq() {
      let errors = [];

      /*if ( !this.isValid(this.dataEquipment.addressT.country) || (this.dataEquipment.addressT.country == 'Соответствие') ){ this.dataEquipment.addressT.country = null;}
                if ( !this.isValid(this.dataEquipment.addressT.region) || (this.dataEquipment.addressT.region == 'Соответствие') ){ this.dataEquipment.addressT.region = null; }
                if ( !this.isValid(this.dataEquipment.addressT.city) || (this.dataEquipment.addressT.city == 'Соответствие') ){ this.dataEquipment.addressT.city = null; }
                if ( !this.isValid(this.dataEquipment.addressT.street) || (this.dataEquipment.addressT.street == 'Соответствие') ){ this.dataEquipment.addressT.street = null; }
                if ( !this.isValid(this.dataEquipment.addressT.streetN) || (this.dataEquipment.addressT.streetN == 'Соответствие') ){ this.dataEquipment.addressT.streetN = null;}
                if ( !this.isValid(this.dataEquipment.addressT.index) || (this.dataEquipment.addressT.index == 'Соответствие') ){ this.dataEquipment.addressT.index = null;}*/
      if (
        !this.isValid(this.dataEquipment.address) &&
        !this.position.latitude
      ) {
        errors.push(this.$t("tasks.errors.address"));
      }
      if (!this.isValid(this.dataEquipment.ExternalName)) {
        errors.push(this.$t("equipm.errors.nameEq"));
      }
      if (!this.isValid(this.dataEquipment.images)) {
        errors.push(this.$t("equipm.errors.imgs_no"));
      }

      if (errors.length < 1) {
        let dataRequest = {
          serial: this.dataEquipment.serial,
          nameEq: this.dataEquipment.ExternalName,
          address: this.dataEquipment.addressT,
          fulladdress: this.dataEquipment.address,
          position: this.position,
          arrayImage: this.dataEquipment.images,
          arrayImage2: this.dataEquipment.images2,
          guid: this.dataEquipment.guid,
        };

        if (this.isValid(this.dataEquipment.serial)) {
          this.makeQuery("/service/activeproduct", {
            dataRequest: dataRequest,
            token: this.$store.getters.getUserToken,
          })
            .then((result) => {
              this.showNotification(
                "custom-success",
                "Activated!",
                this.$t("titles.equipment") + " " + this.dataEquipment.serial,
                -1
              );
              this.filterType = null;
            })
            .catch((result) => {
              this.showNotification("custom-error", "Error", result);
              this.filterType = null;
            });
        }
      } else {
        for (let i = 0; i < errors.length; i++) {
          this.showNotification("custom-error", "Error input", errors[i]);
        }
      }
    },
    getTypeTit(word) {
      for (let i = 0; i < this.$store.state.eq_type.length; i++) {
        if (this.$store.state.eq_type[i].name == word) {
          return this.$t(this.$store.state.eq_type[i].translate);
        }
      }
    },

    addSerial() {
      if (this.isValid(this.dataEquipment.serial)) {
        let ser = this.checkPattSer(this.dataEquipment.serial);
        if (ser) {
          this.dataEquipment.serial = ser;
        } else {
          this.dataEquipment.serial = null;
          return;
        }

        if (ser.indexOf("se-") < 0) {
          ser = "ме-" + ser.split("-")[1];
        }
        this.dataEquipment.serial = ser;

        let ind_find = null;

        for (let i = 0; i < this.activating.serials.length; i++) {
          if (this.dataEquipment.serial == this.activating.serials[i].serial) {
            //serial
            ind_find = i;
            break;
          }
        }
        if (ind_find == null) {
          let dataRequest = {
            serial: this.dataEquipment.serial,
            userGuid: this.$store.getters.getGuidUser,
          };
          this.activating.serials.push({
            serial: JSON.parse(JSON.stringify(this.dataEquipment.serial)),
            check: false,
          });
          if (this.activating.address == null) {
            this.makeQuery("/service/productSerial", {
              dataRequest: dataRequest,
              token: this.$store.getters.getUserToken,
            })
              .then((result) => {
                if (result.Adress != undefined) {
                  this.activating.address = result.Adress;
                }
              })
              .catch((result) => {
                this.showNotification("custom-error", "Error", result);
              });
          }
        }
        this.dataEquipment.serial = null;
      }
    },
    showActEqs() {
      this.showinfo = false;
      this.actEqs = true;
      this.actGroupEq = true;
      this.discardAct();
    },
    checkMain(item) {
      if (item.check) {
        //зняти
        item.check = false;
      } else {
        for (let i = 0; i < this.activating.serials.length; i++) {
          this.activating.serials[i].check = false;
        }
        item.check = true;
      }
    },
    activatingMulti() {
      let yay = false;
      let errors = [];

      if (!this.isValid(this.dataEquipment.images)) {
        errors.push(this.$t("equipm.errors.imgs_no"));
      }

      if (errors.length > 0) {
        for (let i = 0; i < errors.length; i++) {
          this.showNotification("custom-error", "Error input", errors[i]);
        }
      }

      if (this.activating.serials.length > 0) {
        this.activating.main = null;

        for (let i = 0; i < this.activating.serials.length; i++) {
          if (this.activating.serials[i].check) {
            this.activating.main = this.activating.serials[i].serial;
            break;
          }
        }

        let dataRequest = {
          serials: [],
          name: this.activating.name,
          coordinates: this.position,
          address: this.activating.address,
          arrayImage: this.dataEquipment.images,
          arrayImage2: this.dataEquipment.images2,
        };

        //якщо багато

        if (this.activating.serials.length > 1) {
          if (this.activating.main == null) {
            this.showNotification("custom-error", $t("errors.mainSer"), "");
            return;
          } else {
            for (let i = 0; i < this.activating.serials.length; i++) {
              if (this.activating.main == this.activating.serials[i].serial) {
                dataRequest.serials.push({
                  serial: this.activating.serials[i].serial,
                  main: null,
                });
              } else {
                dataRequest.serials.push({
                  serial: this.activating.serials[i].serial,
                  main: this.activating.main,
                });
              }
            }
            yay = true;
          }
        } else if (this.activating.serials.length == 1) {
          dataRequest.serials.push({
            serial: this.activating.serials[0].serial,
            main: null,
          });
          yay = true;
        }

        if (yay) {
          this.makeQuery("/service/updateAcivateProduct", {
            dataRequest: dataRequest,
            token: this.$store.getters.getUserToken,
          })
            .then((result) => {
              this.actEqs = false;
              this.filterType = null;
              this.actGroupEq = false;

              this.discardAct();
              this.showNotification(
                "custom-success",
                this.$t("equipm.titles.actEqs"),
                this.$t("equipm.titles.activated")
              );
            })
            .catch((result) => {
              this.showNotification("custom-error", "Error", result);
              this.filterType = null;
              this.actEqs = false;
              this.actGroupEq = false;
            });
        }
      }
    },
    getQRSerial(serial) {
      if (this.showinfo) {
        this.dataEquipment.serial = serial;
        this.addSerial();
      } else {
        this.getEqInfo(serial);
      }
    },
    closingQr(payload) {
      if (
        this.filterType &&
        !this.showinfo &&
        !this.actEqs &&
        this.dataEquipment.serial == null
      ) {
        this.filterType = null;
      }
    },
    typeTitle: function () {
      if (!this.filterType) {
        return this.$t("equipm.titles.filtrType");
      } else {
        for (let i = 0; i < this.$store.state.eq_type.length; i++) {
          if (this.filterType == this.$store.state.eq_type[i].id) {
            return this.$t(this.$store.state.eq_type[i].translate);
          }
        }
      }
    },
    closeModalMap: function () {
      this.modalMap.position = { lat: 0, lng: 0 };
      this.$modals.hide("map-modal");
    },
    showModalMap(item) {
      if (!e) var e = window.event;
      e.cancelBubble = true;
      if (e.stopPropagation) e.stopPropagation();

      //запит по координати за серійнком
      if (item.coordinate.lng != null && item.coordinate.lat != null) {
        //resData[i].coordinate = {lat: null, lng: null};
        this.modalMap.position.lat = item.coordinate.lat;
        this.modalMap.position.lng = item.coordinate.lng;
        this.modalMap.title = item.Goods + " (" + item.SerialNumber + ")";
        this.$modals.show("map-modal");
      } else {
        this.showNotification(
          "custom-info",
          this.$t("equipm.table.location"),
          this.$t("errors.emptyGPS")
        );
      }
    },
    showModalMapByAddr(address, title) {
      if (address != null && address.length > 5) {
        this.getCoords(address).then((result) => {
          if (result.results.length > 0) {
            this.modalMap.position.lat =
              result.results[0].geometry.location.lat;
            this.modalMap.position.lng =
              result.results[0].geometry.location.lng;

            this.modalMap.title = title;
            this.$modals.show("map-modal");
          }
        });
      }
    },
  },
  computed: {
    titleRefr: function () {
      if (this.dataEquipment.refrigerant.name != "") {
        return (
          this.dataEquipment.refrigerant.name +
          " (" +
          this.dataEquipment.refrigerant.weight +
          ")"
        );
      }
    },
  },
  components: {},
  watch: {
    actEqs: function (newVal, oldVal) {
      if (oldVal == false && newVal == true) {
        this.discardAct();
        this.showinfo = false;
      }
    },
    "dataEquipment.tabs.info": function (newVal, oldVal) {
      if (oldVal == false && newVal == true) {
        this.dataEquipment.tabs.history = false;
      }
    },
    "dataEquipment.tabs.history": function (newVal, oldVal) {
      if (oldVal == false && newVal == true) {
        this.dataEquipment.tabs.info = false;

        if (this.dataEquipment.history.length < 1) {
          this.loadHistory();
        }
      }
    },
    filterType: function (newVal, oldVal) {
      if (oldVal && newVal == null) {
        //очистка всього
        this.discardAct();
        this.showinfo = false;
        this.actEqs = false;
      } else if (newVal && oldVal == null) {
        if (newVal == 3) {
          this.showActEqs();
        } else {
          this.showModalQR();
        }
      }
    },
  },
  created() {
    this.checkAuthorized().then((result) => {
      this.getGPS().then((result) => {
        this.position.latitude = result.latitude;
        this.position.longitude = result.longitude;
        this.position.accuracy = result.accuracy;

        console.log(result);
      });
    });
  },
  mounted() {
    $(function () {
      $('[data-toggle="tooltip"]').tooltip();
    }); // для Hint jQuery
  },
};
</script>

<style scoped>
.table th > .table td {
  padding: 0.75rem 1rem;
}
.col-xs-4 {
  padding: 0;
}
.inputfile {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
#file_loader,
#file_loader2 {
  margin: 0px 0px 0px 0px;
  padding: 0px 0px 0px 0px;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/pages/activation.vue